const ITEMS = [
    "HEAT", "TECHNOLOGY", "A STRONGER TOMORROW",
    "ELECTRIC INDUSTRIAL FURNACES", "PROCESS SYSTEMS", "AUTOMATION",
    "PRECISION CONTROL", "ENGINEERED FOR EXTREME POSSIBILITIES",
];

export const Marquee = () => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div className="relative overflow-hidden border-y border-brand-line bg-brand-ink py-5" data-testid="brand-marquee">
            <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center gap-10">
                        <span className="font-display text-lg sm:text-xl font-bold tracking-[0.2em] text-slate-500 uppercase">
                            {item}
                        </span>
                        <span className="h-1.5 w-1.5 rotate-45 bg-brand-ember" />
                    </span>
                ))}
            </div>
        </div>
    );
};
